import React from "react";
import PhoneNumber from './PhoneNumber';

const Field = (props) => {
  let text = props.value === undefined || props.value === null || props.value === '' ? '-' : props.value
  if (props.toUpper) text = text.toUpperCase()
  if (props.humanize) text = text.replace(/^[\s_]+|[\s_]+$/g, '').replace(/[_\s]+/g, ' ').replace(/^[a-z]/, function(m) { return m.toUpperCase() })

  if (props.children) {
    return (
      <div className="row hover-row" style={{fontSize: 14}}>
        <div className="col-sm-5" style={{fontWeight: 'bold'}}>{props.label}</div>
        <div className="col-sm-7" style={{marginBottom: 8}}>
          {props.children}
        </div>
      </div>
      )
  }

  if (props.blockDisplay) {
    return (
    <div className="row hover-row" style={{fontSize: 14}}>
      <div className="col-sm-12" style={{fontWeight: 'bold'}}>{props.label}</div>
      <div className="col-sm-12" style={{marginBottom: 8}}>
        {text.split('\n').map((item, key) => {
          return <span key={key}>{item}<br/></span>
        })}
        </div>
    </div>
    )
  }

  const requiredFieldMissing = props.required && (!text || text.length === 0 || text === '-')

  return (
    <div className="row hover-row" style={{fontSize: 14}}>
      <div className="col-sm-5" style={{fontWeight: 'bold'}}>{props.label}</div>
      <div className={`col-sm-7 ${requiredFieldMissing && 'text-danger'}`}>
        {requiredFieldMissing
          ? <strong>(required)</strong>
          : <span>{props.dialer ? <PhoneNumber number={text}></PhoneNumber> : text}</span>
        }

      </div>
    </div>
  )
}

export default Field